import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WithdrawConfirmation = ({ application, onConfirm, onCancel }) => {
  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[1200] flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg w-full max-w-md p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={24} className="text-error" />
          </div>
          <h2 className="text-xl font-semibold text-foreground">Withdraw Application</h2>
        </div>

        <p className="text-sm text-muted-foreground mb-6">
          Are you sure you want to withdraw your application for <span className="font-semibold text-foreground">{application?.jobTitle}</span> at <span className="font-semibold text-foreground">{application?.companyName}</span>?
        </p>

        <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4 mb-6">
          <div className="flex gap-3">
            <Icon name="Info" size={20} className="text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-yellow-900 dark:text-yellow-100">
              <p className="font-medium mb-1">Important:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>This action cannot be undone</li>
                <li>You will need to reapply if you change your mind</li>
                <li>The employer will be notified of your withdrawal</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex gap-3">
          <Button
            variant="outline"
            fullWidth
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            fullWidth
            onClick={() => onConfirm(application)}
          >
            Withdraw Application
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WithdrawConfirmation;